var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fas fa-ghost"}),_vm._v(" "+_vm._s(_vm.message || 'Loading')+"…\n  ")]):_vm._e(),(!_vm.loading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }